<button mat-mini-fab #iconButton (click)="click($event)"
        [color]="colour"
        [id]="id"
        [permission-lock]="permissions"
        [disabled]="!preconditions || disabled"
        type="button">
  <i aria-hidden="true" [ngClass]="class"></i>
</button>
